import {
  DISPLAY_VERSION_BAR,
  HIDE_ALERT,
  HIDE_CONFIRMATION,
  HIDE_FILE,
  HIDE_FILE_EXPLORER,
  SHOW_ALERT,
  SHOW_CONFIRMATION,
  SHOW_FILE,
  SHOW_FILE_EXPLORER,
  TOGGLE_EXPAND_TABLE,
  TOGGLE_SIDEBAR,
  UPDATE_VERSION
} from 'actions/app';
import { combineReducers } from 'redux';

/**
 * @param {AppUiState} [state]
 * @param {Action} [action]
 * @returns {AppUiState}
 */
const uiReducer = (state = {}, action = { type: '', payload: {} }) => {
  const { type, payload } = action;
  switch (type) {
    case SHOW_ALERT:
      return {
        ...state,
        alerts: [
          ...state.alerts,
          {
            key: new Date().getTime() + Math.random(),
            ...payload
          }
        ]
      };
    case HIDE_ALERT:
      return {
        ...state,
        alerts: state.alerts.filter(alert => alert.key !== payload)
      };
    case SHOW_CONFIRMATION:
      return {
        ...state,
        confirmation: payload
      };
    case HIDE_CONFIRMATION:
      return {
        ...state,
        confirmation: null
      };
    case SHOW_FILE:
      return {
        ...state,
        activePdf: payload
      };
    case HIDE_FILE:
      return {
        ...state,
        activePdf: null
      };
    case SHOW_FILE_EXPLORER:
      return {
        ...state,
        fileExplorer: payload
      };
    case HIDE_FILE_EXPLORER:
      return {
        ...state,
        fileExplorer: null
      };
    case DISPLAY_VERSION_BAR:
      return {
        ...state,
        showVersionBar: true,
        version: payload
      };
    case UPDATE_VERSION:
      return {
        ...state,
        version: payload
      };
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        isSidebarOpen: payload
      };
    case TOGGLE_EXPAND_TABLE: {
      const expandedTableId = payload === false ? null : payload;
      return {
        ...state,
        expandedTableId,
        isTableExpanded: expandedTableId != null
      };
    }
    default:
      return state;
  }
};

/**
 * @param {AppDomainState} [state]
 * @param {Action} [action]
 * @returns {AppDomainState}
 */
const domainReducer = (state = {}, action = { type: '', payload: {} }) => {
  const { type } = action;
  switch (type) {
    default:
      return state;
  }
};

const appReducer = combineReducers({ domain: domainReducer, ui: uiReducer });

export default appReducer;
